export default "__VITE_ASSET__CWgZdGVX__"